import { render, staticRenderFns } from "./OnboardingLocationForm.vue?vue&type=template&id=02ab2ce0&scoped=true"
import script from "./OnboardingLocationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingLocationForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OnboardingLocationForm.vue?vue&type=style&index=0&id=02ab2ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ab2ce0",
  null
  
)

export default component.exports